import React from 'react';
import { Box, Text, Heading } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { useProfileContext } from '@components/Contexts/ProfileContext';
import { CheckmarkSuccessSvg } from '@components/Images/CheckmarkSuccessSvg';

interface Props {
  isMobile?: boolean;
}

const BriefContactStatusModalContentSuccess = ({ isMobile }: Props) => {
  const { partnerProfile } = useProfileContext();
  const partnerName = partnerProfile?.professionalInformation?.businessName;

  const { t } = useTranslation();
  return (
    <Box
      direction="vertical"
      align="center"
      textAlign="center"
      padding="24px"
      height="100%"
    >
      <Box
        marginBottom={isMobile ? '18px' : '24px'}
        marginTop={isMobile ? '54px' : '24px'}
      >
        <CheckmarkSuccessSvg />
      </Box>
      <Box marginBottom="18px">
        <Heading as="h3" size={isMobile ? 'extraLarge' : 'large'}>
          {t(
            'marketplace.profile-page.contact-form.submit-success-modal.title',
            { partnerName },
          )}
        </Heading>
      </Box>
      <Box marginBottom="24px">
        <Text size="medium" weight="thin">
          {t(
            'marketplace.profile-page.contact-form.submit-success-modal.subtitle',
          )}
        </Text>
      </Box>
    </Box>
  );
};

export default BriefContactStatusModalContentSuccess;
